// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"294":"b2d121590d71b8cc","4065":"ec26da7ea6251a74","9712":"671f995559fab6f6"}[chunkId] + ".js";
};